import { useForm } from 'react-hook-form'

import { ContainerForm } from '../../../components/form/ContainerForm'
import { yupResolver } from '@hookform/resolvers/yup'
import { FieldLogin, schema } from './ValidationSchema'
import { Link } from 'react-router-dom'

export default function LoginPage() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FieldLogin>({
    resolver: yupResolver(schema),
  })

  const submit = () => console.log(1)
  return (
    <>
      <form onSubmit={handleSubmit(submit)}>
        <h3>Entrar</h3>
        <ContainerForm textBtn='Entrar'>
          <div className={`field ${errors.name ? 'error' : ''}`}>
            <label htmlFor='name'>Nome</label>
            <input type='text' id='name' {...register('name')} />
            {errors.name && <p>{errors.name.message}</p>}
          </div>
          <div className={`field ${errors.password ? 'error' : ''}`}>
            <label htmlFor='password'>Senha</label>
            <input type='password' id='password' {...register('password')} />
            {errors.password && <p>{errors.password.message}</p>}
          </div>
        </ContainerForm>
      </form>
      <p>
        Não tem uma conta <Link to='/users/register'>Clique aqui</Link>
      </p>
    </>
  )
}
